import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { GeoAreaLoyaltyProgramKpi } from '../models/dtos/geo-area-loyalty-program-kpi';
import { GeoAreaLoyaltyProgramQualityKpi } from '../models/dtos/geo-area-loyalty-program-quality-kpi';
import { GeoAreaLoyaltyProgramBonusFollowup } from '../models/dtos/geo-area-loyalty-program-bonus-followup';
import { GeoAreaExcludedPartner } from '../models/dtos/geo-area-excluded-partner';
import { GeoAreaMslMonitoringKpi } from '../models/dtos/geo-area-msl-monitoring-kpi';
import { GeoAreaSipKpi } from '../models/dtos/geo-area-sip-kpi';
import { GeoAreaServiceRateKpi } from '../models/dtos/geo-area-service-rate-kpi';
import { SkuMslKpi } from 'src/app/assabil-kernel/models/entities/control-tables/sku-msl-kpi-entity';
import { GeoAreaMslRespectMonitoringKpi } from '../models/dtos/geo-area-msl-respect-monitoring-kpi';


@Injectable({
    providedIn: 'root'
})
export class SpecificDanoneService {

    constructor(
        private networkService: LeanNetworkService,
        public userService : UserService) {

    }


    geoAreaServiceRateKpisGet(geoAreaCode: string, date: Date, basedOnInvoice : boolean , basedOnOrder : boolean) : Promise<GeoAreaServiceRateKpi> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = geoAreaCode;
        request.dteArg1 = date;
        request.blnArg1 = basedOnInvoice;
        request.blnArg2 = basedOnOrder;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/danone/geoAreaServiceRateKpisGet', request).then(result => {
                return resolve(result.geoAreaServiceRateKpi);
            }, error => {
                reject(error);
            });
        });
    }
    
    geoAreaSipKpisGet(geoAreaCode: string, date: Date) : Promise<GeoAreaSipKpi> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = geoAreaCode;
        request.dteArg1 = date;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/danone/geoAreaSipKpisGet', request).then(result => {
                return resolve(result.geoAreaSipKpi);
            }, error => {
                reject(error);
            });
        });
    }


    geoAreaMslRespectMonitoringKpisGet(geoAreaCode: string, date: Date) : Promise<GeoAreaMslRespectMonitoringKpi> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = geoAreaCode;
        request.dteArg1 = date;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/danone/geoAreaMslRespectMonitoringKpisGet', request).then(result => {
                return resolve(result.geoAreaMslRespectMonitoringKpi);
            }, error => {
                reject(error);
            });
        });
    }


    geoAreaMslMonitoringKpisGet(geoAreaCode: string, date: Date) : Promise<GeoAreaMslMonitoringKpi> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = geoAreaCode;
        request.dteArg1 = date;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/danone/geoAreaMslMonitoringKpisGet', request).then(result => {
                return resolve(result.geoAreaMslMonitoringKpi);
            }, error => {
                reject(error);
            });
        });
    }


    geoAreaLoyaltyProgramKpisGet(geoAreaCode: string, date: Date) : Promise<GeoAreaLoyaltyProgramKpi> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = geoAreaCode;
        request.dteArg1 = date;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/danone/geoAreaLoyaltyProgramKpisGet', request).then(result => {
                return resolve(result.geoAreaLoyaltyProgramKpi);
            }, error => {
                reject(error);
            });
        });
    }

    geoAreaLoyaltyProgramQualityKpisGet(geoAreaCode: string, date: Date) : Promise<GeoAreaLoyaltyProgramQualityKpi> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = geoAreaCode;
        request.dteArg1 = date;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/danone/geoAreaLoyaltyProgramQualityKpisGet', request).then(result => {
                return resolve(result.geoAreaLoyaltyProgramQualityKpi);
            }, error => {
                reject(error);
            });
        });
    }

    geoAreaLoyaltyProgramBonusFollowupsGet(geoAreaCode: string, date: Date) : Promise<GeoAreaLoyaltyProgramBonusFollowup> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = geoAreaCode;
        request.dteArg1 = date;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/danone/geoAreaLoyaltyProgramBonusFollowupsGet', request).then(result => {
                return resolve(result.geoAreaLoyaltyProgramBonusFollowup);
            }, error => {
                reject(error);
            });
        });
    }

    danoneMslRespectGeoAreasGet(periodActiveday: Date, itineraryTypeCode : string, partnerClusterCode : string, geoAreaCode : string): Promise<any[]> {

        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    
        request.dteArg1  = periodActiveday;
        request.strArg1  = itineraryTypeCode;
        request.strArg2  = partnerClusterCode;
        request.strArg3  = geoAreaCode;
    
        return new Promise((resolve) => {
            this.networkService.post('sales/danone/danoneMslRespectGeoAreasGet', request).then(result => {
                return resolve(result.danoneMslRespectGeoAreas);   
            });
        });
      }

    danoneMslSkuGeoAreasGet(periodActiveday: Date, productCode : string, geoAreaCode : string): Promise<any[]> {

        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    
        request.dteArg1  = periodActiveday;
        request.strArg1  = productCode;
        request.strArg2  = geoAreaCode;
    
        return new Promise((resolve) => {
            this.networkService.post('sales/danone/danoneMslSkuGeoAreasGet', request).then(result => {
                return resolve(result.danoneMslSkuGeoAreas);   
            });
        });
      }

    danoneMslSkusGet(periodActiveday: Date, itineraryTypeCode : string, geoAreaCode : string): Promise<any[]> {

        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    
        request.dteArg1  = periodActiveday;
        request.strArg1  = itineraryTypeCode;
        request.strArg2  = geoAreaCode;
    
        return new Promise((resolve) => {
            this.networkService.post('sales/danone/danoneMslSkusGet', request).then(result => {
                return resolve(result.danoneMslSkus);   
            });
        });
      }

    danoneSipPartnersGet(periodActiveday: Date, dnProductFamilyCode : string, geoAreaCode : string): Promise<any[]> {

    let request: BaseRequest = new BaseRequest(this.userService.userInfo);

    request.dteArg1  = periodActiveday;
    request.strArg1  = dnProductFamilyCode;
    request.strArg2  = geoAreaCode;

    return new Promise((resolve) => {
        this.networkService.post('sales/danone/danoneSipPartnersGet', request).then(result => {
            return resolve(result.danoneSipPartners);   
        });
    });
  }

    GeoAreaExcludedPartnersGet(startDate: Date, endDate: Date, geoAreaCode : string, productCode : string, brandCode : string): Promise<GeoAreaExcludedPartner> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.dteArg1  = startDate;
        request.dteArg2  = endDate;
        request.strArg1  = geoAreaCode;
        request.strArg2  = productCode;
        request.strArg3  = brandCode;

      return new Promise((resolve, reject) => {
        this.networkService.post('sales/danone/geoAreaExcludedPartnersGet', request).then(result => {
            return resolve(result.geoAreaExcludedPartner);
        }, error => {
            reject(error);
        });
    });
}

  danoneLoyaltyPartnersGet(periodActiveday: Date, loyaltyProgramCode : string, geoAreaCode : string, 
        increase : boolean, decrease: boolean, 
        withPerfVoucher: boolean, withAssetVoucher: boolean, withReturnsVoucher: boolean): Promise<any[]> {

    let request: BaseRequest = new BaseRequest(this.userService.userInfo);

    request.dteArg1  = periodActiveday;
    request.strArg1  = loyaltyProgramCode;
    request.strArg2  = geoAreaCode;

    request.blnArg1  = increase;
    request.blnArg2 = decrease;
    request.blnArg3  = withPerfVoucher;
    request.blnArg4  = withAssetVoucher;
    request.blnArg5  = withReturnsVoucher;

    return new Promise((resolve) => {
        this.networkService.post('sales/danone/danoneLoyaltyPartnersGet', request).then(result => {
            return resolve(result.danoneLoyaltyPartners);   
        });
    });
  }

  danoneLoyaltyBonusFollowupPartnersGet(periodActiveday: Date, loyaltyProgramCode : string, geoAreaCode : string, 
    withVoucher : boolean, consumedVoucher : boolean, notyetConsumedVoucher : boolean, nearlyExpiredVoucher : boolean): Promise<any[]> {

let request: BaseRequest = new BaseRequest(this.userService.userInfo);

request.dteArg1  = periodActiveday;
request.strArg1  = loyaltyProgramCode;
request.strArg2  = geoAreaCode;

request.blnArg1  = withVoucher;
request.blnArg2  = consumedVoucher;
request.blnArg3  = notyetConsumedVoucher;
request.blnArg4 =  nearlyExpiredVoucher;

return new Promise((resolve) => {
    this.networkService.post('sales/danone/danoneLoyaltyBonusFollowupPartnersGet', request).then(result => {
        return resolve(result.danoneLoyaltyBonusFollowupPartners);   
    });
});
}

  danoneLoyaltyQualityPartnersGet(periodActiveday: Date, loyaltyProgramCode : string, geoAreaCode : string, 
    isPrivilege : boolean, withAbusedAsset: boolean, 
    withVisibleAsset: boolean, withReachableAsset: boolean, withClosedPartner: boolean,
    withDeniedVisit: boolean, withOtherAnomaly: boolean): Promise<any[]> {

    let request: BaseRequest = new BaseRequest(this.userService.userInfo);

    request.dteArg1  = periodActiveday;
    request.strArg1  = loyaltyProgramCode;
    request.strArg2  = geoAreaCode;

    request.blnArg1  = isPrivilege;
    request.blnArg2  = withAbusedAsset;
    request.blnArg3  = withVisibleAsset;
    request.blnArg4  = withReachableAsset;
    request.blnArg5  = withClosedPartner;
    request.blnArg6  = withDeniedVisit;
    request.blnArg7  = withOtherAnomaly;

    return new Promise((resolve) => {
        this.networkService.post('sales/danone/danoneLoyaltyQualityPartnersGet', request).then(result => {
            return resolve(result.danoneLoyaltyQualityPartners);   
        });
    });
    }

    danoneExcludedPartnerListsGet(startDate: Date, endDate: Date, geoAreaCode : string, productCode : string, 
                                  brandCode : string, partnerclusterCode : string, excluded : boolean): Promise<any[]> {

    let request: BaseRequest = new BaseRequest(this.userService.userInfo);

    request.dteArg1  = startDate;
    request.dteArg2  = endDate;
    request.strArg1  = geoAreaCode;
    request.strArg2  = productCode;
    request.strArg3  = brandCode;
    request.strArg4  = partnerclusterCode;

    request.blnArg1  = excluded;

    return new Promise((resolve) => {
        this.networkService.post('sales/danone/danoneExcludedPartnerListsGet', request).then(result => {
            return resolve(result.danoneExcludedPartnerLists);   
        });
    });
  }

}
